// extracted by mini-css-extract-plugin
export var quantityInput = "_fu-0";